import React from 'react';
import InDeveloping from '../InDeveloping/InDeveloping';
import InfoCard from '../../common/InfoCard/InfoCard';
import useCardPagination from '../../../../../hooks/useCardPagination';

const PaymentsCard = ({ disabled, className, payments }) => {
  const { shownItems, pagination } = useCardPagination(payments, 6);
  return (
    <InfoCard
      title="Платежи"
      action={payments?.length && !disabled && pagination}
      className={className}
    >
      {disabled && <InDeveloping />}
    </InfoCard>
  );
};

export default PaymentsCard;
